import React, { useEffect, useState } from 'react'
import Image from '../../../components/common/Image'
import { serviceInfo } from './text'
import Toggle from '../../../components/common/toggle'
import { GetRangePlaceInfo, GetPlaceInfoByCounty, GetPlaceAutocomplete, GetPlaceDetails } from '../../../api/map8'
import Loading from '../../../components/common/loading'
import Modal from '../../../components/common/Error/Modal'
import Select from '../../../components/common/Select'
import { GetTowns } from '../../../api/system'
import AutoComplete from '../../../components/common/autocomplete'
import Advertisement from './Advertisement'

// import { GetInfoByAddressOrXY } from '../../../api/map8'
// import Input from '../../../components/common/Input'

const Location = ({ data, serviceType, userInfo, identity,onBack, parameters, onConfirm, County }) => {
  const [filterObj, setFilterObj] = useState(
    { city: data.city  } )
  const [submitData, setSubmitData] = useState({
    type: { id: 1, name: "原廠" },
    city: data.city
  })
  const [region, setRegion] = useState({ address: "" })
  const [stations, setStations] = useState(null)
  const [towns, setTowns] = useState([])
  const [modal, setModal] = useState(null)
  const [selectAd, setSelectAd] = useState(null)
  //優惠身分類別為車商
  let options = identity?.OfferDetailType.id === 0?[
    { id: 1, name: "原廠" }, { id: 3, name: "指定目的地" },
  ]:[
    { id: 1, name: "原廠" }, { id: 2, name: "一般保養廠" }, { id: 3, name: "指定目的地" },
  ]
  const btnDisabled = () => {
    let unvalid = true
    if (region.address || (region.city && region.town)) {
      unvalid = false
    }
    return unvalid
  }
  const fetchOption = async (val) => {
    let type = submitData.type
    setStations(null)
    if (type.id < 3) {
      let GetPlaceAutocomplete_keyword = ''
      let origin = {}
      //國道高速
      if (data.freeway?.freewayListID) {
        let freeway = data.freeway
        //id ===1 國道分隊;  id ===2 休息站
        if (data.freeway_type.id < 3) {
          GetPlaceAutocomplete_keyword = `${data.freeway_type.id === 1 ? data.freeway_sub.typeName : ''}${data.freeway_sub.name}${data.direction?.name}`

        } else {
          GetPlaceAutocomplete_keyword = `${freeway.nickName}-${data.mileage}K`
        }

      }

      //快速道路
      if (data.expressway_id?.expressway_id) {
        GetPlaceAutocomplete_keyword = `${data.expressway_id
          .name.replace("線", "")}-${data.mileage}K`
      }

      if (GetPlaceAutocomplete_keyword) {
        //取得國道高速/快速道路的座標
        let place = await GetPlaceAutocomplete({ keyword: GetPlaceAutocomplete_keyword })
        if (place?.statusCode === 200) {
          let place_id = place.result[0].place_id
          let GetPlaceDetails_res = await GetPlaceDetails({ place_id: place_id })
          if (GetPlaceDetails_res?.statusCode === 200) {
            const { location } = GetPlaceDetails_res.result.geometry
            const { postcode, city, town } = GetPlaceDetails_res.result
            origin.lat_s = location.lat
            origin.lng_s = location.lng
            let county_filter = County.filter(c => c.name === city?.replace("台","臺"))
            let citycode = county_filter?.[0].value
            origin.county_code = citycode
            if(!submitData.switch){
              setFilterObj({city : county_filter?.[0] || data.city})
            }

            // reform_origin.origin_address = citycode`${postcode}${city}${town}${obj.service_location.origin_address}`
          }
        }
      }
      let obj = {
        VmpTypeID: type.id,
        lat_s: data.position.lat, lng_s: data.position.lng,
        county_code: submitData.city.value,
        ...origin,
      }
      
      if (submitData.town) obj.town_code = submitData.town.townCode
      if(submitData.switch) obj.county_code = submitData.city.value
      if(data.destination?.switch){
        obj.county_code = data.destination.city.value
        if(data.destination.town){
           obj.town_code = data.destination.town.townCode
        }
      }
      if (type.id === 1) {
        obj =
        {
          ...obj,
          brand_id: userInfo.brand.brandId,
        }
      }
      let res = await GetPlaceInfoByCounty(obj)
      if (res?.statusCode === 200) {
        let { result } = res
        //置頂有廣告之保養廠
        setStations(result.sort((a, b) => b.advertisements.length - a.advertisements.length))
      }
    } else {
      setStations([])
    }
  }
  const fetchTown = async (obj, town) => {
    let res = await GetTowns({ countyCode: obj.value })
    if (res) {
      setTowns(res)
      if (town) {
        let filter = res.filter(r => r.townName.indexOf(town) > -1)
        return filter.length ? filter[0] : null
      }
    }

  }
  const searchTown = async () => {
    let county = parameters.County.data
    let city = data.position.city.name
    let town = data.position.town.name
    let obj = { ...submitData }
    if (data.destination) obj.type = data.destination.type
    let filter = county.filter(c => c.name === city)
    if (filter.length) {
      obj.city = filter[0]
      // let town_obj = await fetchTown(filter[0], town[1])
      // obj.town = town_obj
    }
    if (data.destination) {
      if (data.destination.address) {
        setRegion({ address: data.destination.address })
      } else {
        setRegion({ town: data.destination.town, city: data.destination.city })
      }
    }
    setFilterObj(obj)
    setSubmitData(obj)
  }
  const autocomplete = async (val) => {
    let obj = {}
    if (val.length > 2) {
      let res = await GetPlaceAutocomplete({
        keyword: val,
        lat: data.position.lat,
        lng: data.position.lng,
      })
      obj.options = res?.result || []
    }
    setRegion(obj)
  }
  const onSubmit = async (obj) => {
    let destination = {
      ...submitData
    }

    if (obj) {
      destination.vmp_id = obj
    } else {
      if (region.city && region.town) {
        destination.destination_address = `${region.city.name}${region.town.townName}`
      } else {
        let res = await GetPlaceDetails({ place_id: region.address.place_id })
        if (res?.statusCode === 200) {
          let result = res.result
          destination.address = region.address
          destination.destination_name = region.address.name
          destination.destination_address = result.formatted_address
          destination.destination_lat = result.geometry.location.lat
          destination.destination_lng = result.geometry.location.lng
        }
      }
    }
    onConfirm(destination)

  }
  useEffect(() => {
    document.querySelector("body").style.overflow = modal ? "hidden" : "unset";
  }, [modal]);
  useEffect(() => {
    fetchOption()
  }, [submitData])

  useEffect(() => {
    if (parameters && data) {
      searchTown()
    }
  }, [parameters, data])
  return (
    <>
      <div className={`container ${submitData.type.id !== 3 ? 'page_with_footer' : ''}`}>
        <div className="page-header">
          <button className='btn-circle' onClick={onBack}>
            <Image src='/images/icons/arrow_left.svg' />
          </button>
          <div className="page_header__title">
            <h1 className="font-heading">車輛要拖吊去哪？</h1>
            <Toggle
              style={{ marginTop: 16 }}
              defaultValue={submitData.type}
              list={options}
              onChange={(data) => {
                // setFilterObj(null)
                // town:submitData.town
                setSubmitData({ type: data, city: submitData.city })
              }}
            />
          </div>
        </div>

        <div className='destination-block column-flex-grow-container'>
          <div className='flex-grow-1 grid-gap-24'>
            {
              submitData.type.id === 3 ? (<>
                <AutoComplete
                  defaultValue={region.address}
                  placeholder='請輸入地址'
                  disabled={region.city}
                  options={region.options}
                  onChange={(e) => autocomplete(e)}
                  onSelect={(e) => {
                    setRegion({ address: e })
                  }}
                />
                <div className="line-text-center">
                  <p>還不確定地址，先輸入個大概</p>
                </div>
                <Select
                  placeholder="縣市"
                  disabled={region.address}
                  defaultValue={region.city}
                  options={parameters?.County.data || []}
                  onChange={async (data) => {
                    if (region.city && region.city.value === data.value) {
                      setRegion({})
                    } else {
                      await fetchTown(data)
                      setRegion({ city: data })
                    }
                  }}
                />
                <Select
                  placeholder="鄉鎮(市)區"
                  disabled={region.address}
                  defaultValue={region.town}
                  options={towns}
                  nameKey='townName'
                  onChange={async (data) => {
                    let obj = { ...region }
                    if (region.town && region.town.townCode === data.townCode) {
                      setRegion({})
                      delete obj.town
                    } else {
                      obj.town = data
                    }
                    setRegion(obj)
                  }}
                />


              </>) : (<>
                {/* <p className='page-info-title'>以下是起吊點 30 公里內據點，點搜尋查其他地區</p> */}
                <p className='page-info-title'>以下是起吊點據點，點搜尋查其他地區</p>
                {
                  stations ? (
                    <ul className='block-list'>

                      {
                        stations.map(station => (
                          <li key={station.vmpID} onClick={() =>   onSubmit(station)}>
                            <p className='text'>離起點 {station.distance} 公里</p>
                            <p className='title font-heading'>{station.vmpName}</p>
                            <p className='text'>{station.vmpAddress}</p>
                            {
                              station.advertisements.length ? (<>
                                <ul className='add-list'>
                                  {
                                    station.advertisements.map(ad => (
                                      <li key={ad.id}>
                                        <p className='li-title'>{ad.title}</p>
                                        {
                                          ad.summary && (<p>{ad.summary}</p>)
                                        }
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setSelectAd({ station, ad })
                                            // window.open(ad.url, "_blank", )
                                          }}
                                        >
                                          瞭解詳情
                                          <Image src="/images/icons/arrow_left.svg" svg />
                                        </button>
                                      </li>
                                    ))
                                  }
                                </ul>
                              </>) : (<></>)
                            }
                          </li>
                        ))
                      }
                    </ul>
                  ) : (<Loading />)
                }
              </>)
            }

          </div>
        </div>
        {
          submitData.type.id === 3 && (
            <button className='btn'
              disabled={btnDisabled()}
              onClick={() => onSubmit()}
            >確認</button>

          )
        }

      </div>
      {
        submitData.type.id === 1 && stations && (
          <div className='page_footer'>
            <button className='btn' onClick={() => setModal(true)}>
              搜尋其他原廠
            </button>
          </div>
        )
      }
      {
        modal && <Modal element={
          <>
            <p className='modal__block__title font-heading'>請輸入查找區域</p>
            <div className='block'>
              <Select
                placeholder="點擊選擇"
                defaultValue={filterObj.city}
                // nameKey="modelName"
                options={parameters?.County.data || []}
                onChange={async (data) => {
                  // let obj = { ...submitData }
                  // delete obj.town
                  // obj.city = data
                  // setSubmitData(obj)
                  let obj = { ...filterObj }
                  delete obj.town
                  obj.city = data
                  setFilterObj(obj)
                  // fetchOption(obj)
                  await fetchTown(data)
                }}
              />
              <Select
                placeholder="點擊選擇"
                defaultValue={filterObj.town}
                nameKey="townName"
                options={towns || []}
                onChange={(data) => {
                  setFilterObj({ ...filterObj, town: data })
                  // setSubmitData({ ...submitData, town: data })
                }}
              />

              <button
                disabled={!submitData.city && !submitData.town}
                className='btn'
                onClick={() => {
                  setSubmitData({ type: submitData.type, switch:true ,...filterObj })
                  // setFilterObj({ ...submitData })
                  setModal(null)
                }}
              >搜尋</button>
            </div>
          </>
        } />
      }
      {
        selectAd && (<Advertisement data={selectAd}
          onClose={() => setSelectAd(null)}
          onConfirm={() => {
            setSelectAd(null)
            onSubmit(selectAd.station)
          }}
        />)
      }

    </>
  )
}

export default Location